module.exports = __webpack_public_path__ + "static/media/dropdown-icon.10ad26bc.svg";